import {
  BackendServerActionType,
  ButtonElementModel,
  CastUtility,
  ConditionPanelElementModel,
  DevelopDialogScript,
  DevelopScriptServicePack,
  InputCheckboxElementModel,
  InputPartsBaseModel,
  LinkElementModel,
  ListPanelElementModel,
  PanelModel,
  PanelType,
  PartsBaseModel,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';

/**
 * 受領日選択ダイアログのスクリプト
 */
export class ReceiptDateDialogConditionList implements DevelopDialogScript {
  readonly scriptName: string = 'ReceiptDateDialogConditionList';
  mProgramTicketKey: string = '';
  freeWords: string = '';
  checkboxValue: boolean = true;
  constructor() {}

  /**
   * ダイアログが表示された際の初期処理
   * @param panelModels
   * @param service
   * @param receivedData
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack, mProgramTicketKey: any): void {
    //「選択中の番組のみ」にチェックを入れる
    const condition = panelModels.get(PanelType.ConditionPanel) as ConditionPanelElementModel;
    condition.inputPartsList.forEach((inputParts) => {
      if (inputParts.id === 'IsSelectedProgramOnly') {
        const check = inputParts as InputCheckboxElementModel;
        check.isChecked = true;
      }
    });

    this.mProgramTicketKey = mProgramTicketKey;
    this.search(null, this.checkboxValue, panelModels, service);
  }

  /**
   * ダイアログで何らかのボタンが押下された際の処理
   * @param panelModels パネルモデルのマップ
   * @param clickedButtonElement 押下されたボタンのモデル
   * @param service サービス
   * @returns
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    if (clickedButtonElement.id.includes('LinkReceiptDateButton')) {
      const ticketKey = this.getSelectedTicketKey(panelModels, clickedButtonElement);
      service.dialogService.closeViewDialog(ticketKey);
      return;
    }
  }

  /**
   * 独自のバリデーションチェック
   * @param panelModels
   * @returns
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }
  /**
   * input-partsのイベント
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ) {
    if (inputPartsModel.id === 'IsSelectedProgramOnly' && inputPartsModel.lastEvent?.type === 'change') {
      this.checkboxValue = inputPartsModel.value;
      this.search(this.freeWords, this.checkboxValue, panelModels, service);
    } else if (inputPartsModel.id === 'FreeWords' && inputPartsModel.lastEvent?.type === 'change') {
      this.freeWords = inputPartsModel.value;
      this.search(this.freeWords, this.checkboxValue, panelModels, service);
    }
  }

  /**
   * リンクが押下されたときの処理
   * @param panelModels パネルモデルのマップ
   * @param clickedLinkElement 押下されたリンクモデル
   * @param service スクリプトのサービス
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ) {}

  /**
   * 選択されたチケットキーを取得する
   * @param panelModels
   * @param clickedLinkElement
   * @returns
   */
  getSelectedTicketKey(panelModels: Map<PanelType, PanelModel>, clickedButtonElement: ButtonElementModel): string {
    const index = this.getIndex(clickedButtonElement);
    const listPanel = panelModels.get(PanelType.ListPanel) as ListPanelElementModel;
    const row = listPanel.listElementModel.bodyModel.rows[index];

    return row.commonDBValue.ticketKey;
  }

  /**
   * 検索処理を実行する
   * @param contentText
   * @param checkboxValue
   * @param panelModels
   * @param service
   */
  search(
    freeWords: string | null,
    checkboxValue: boolean,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ) {
    // 検索処理
    if (freeWords === null) {
      freeWords = '';
    }

    var condition = {
      MProgramTicketKey: '',
      FreeWords: freeWords,
    };

    if (checkboxValue == true) {
      condition = {
        MProgramTicketKey: this.mProgramTicketKey,
        FreeWords: freeWords,
      };
    }

    const listPanel = panelModels.get(PanelType.ListPanel) as ListPanelElementModel;
    const setLabelAndClassCallBack = () => {
      this.setLabelAndClass(panelModels);
    };

    listPanel.fetchList('ReceiptDate', condition, setLabelAndClassCallBack, ViewType.Edit);
  }

  /**
   *受領日リンクボタンのラベルを入力する。
   * @param panelModels
   */
  setLabelAndClass(panelModels: Map<PanelType, PanelModel>) {
    const listPanel = panelModels.get(PanelType.ListPanel) as ListPanelElementModel;
    const bodyModel = listPanel.listElementModel.bodyModel;
    bodyModel.rows.forEach((row) => {
      const linkButton = row.getCell('LinkReceiptDateButton');
      if (linkButton) {
        linkButton.cellModel.label = 'この受領日をリンク';
      }
    });
  }

  /**
   * 行数を取得する
   * @param element
   * @returns
   */
  getIndex(element: PartsBaseModel): number {
    return CastUtility.anyToNumber(element.id.split('_')[1]);
  }
}
